import Swal from "sweetalert2";
import faradayApi from "../../api/faradayApi";


export const deleteEventRegister = async (e, succesMsg, errorMsg, cancelButton, confirmButton, deleteConfirm) => {
    const { value } = await Swal.fire({
        text: `${deleteConfirm} ${e.name}`,
        showCancelButton: true,
        confirmButtonColor: '#001B60',
        cancelButtonText: cancelButton,
        confirmButtonText: confirmButton,
        reverseButtons: true
    })
    value && onConfirm(e.id, succesMsg, errorMsg, e.name)
}

const onConfirm = async (eventId, succesMsg, errorMsg, name) => {
    try {
        const { data } = await faradayApi.put('/eventRegister/editByUser', {eventId, confirmsAttendance: 'No', principalAssistant: '', companions:0, comments: '' });

        data.data !== 0 && !data.error ?
            Swal.fire({
                confirmButtonColor: '#001B60',
                text: `${succesMsg} ${name}`,
                icon: "success",
            })
            :
            Swal.fire({
                confirmButtonColor: '#001B60',
                text: errorMsg,
                icon: "error",
            })
    } catch (error) {
        console.log(error)
        Swal.fire({
            confirmButtonColor: '#001B60',
            text: errorMsg,
            icon: "error",
        })
    }
}

export const deleteEventRegisterById = async (e, succesMsg, errorMsg, cancelButton, confirmButton, deleteConfirm) => {
    const { value } = await Swal.fire({
        text: `${deleteConfirm} ${e.name}`,
        showCancelButton: true,
        confirmButtonColor: '#001B60',
        cancelButtonText: cancelButton,
        confirmButtonText: confirmButton,
        reverseButtons: true
    })
    value && onConfirmById(e.id, succesMsg, errorMsg, e.name)
}

const onConfirmById = async (id, succesMsg, errorMsg, name) => {
    try {
        const { data } = await faradayApi.delete('/eventRegister/deleteById', { data: { id } });

        data.data !== 0 && !data.error ?
            Swal.fire({
                confirmButtonColor: '#001B60',
                text: `${succesMsg} ${name}`,
                icon: "success",
            })
            :
            Swal.fire({
                confirmButtonColor: '#001B60',
                text: errorMsg,
                icon: "error",
            })
    } catch (error) {
        console.log(error)
        Swal.fire({
            confirmButtonColor: '#001B60',
            text: errorMsg,
            icon: "error",
        })
    }
}

export const editEventRegistered = async (formValues, succesMsg, errorMsg) => {
    try {

        const { data } = await faradayApi.put('/eventRegister', formValues)

        if (data.ok === true) {
            Swal.fire({
                confirmButtonColor: '#001B60',
                text: `${succesMsg}`,
                icon: "success",
            })
            return true
        } else {
            Swal.fire({
                confirmButtonColor: '#001B60',
                text: errorMsg,
                icon: "error",
                iconColor: '#FF7765'
            })
            return false
        }

    } catch (error) {
        console.log(error)
        Swal.fire({
            confirmButtonColor: '#001B60',
            text: error,
            icon: "error",
            iconColor: '#FF7765'
        })

    }
}